module.exports = class ContentRatings {
    constructor() {
        /** @type {IdNamePair} */
        this.maturityLevel    = null;

        /** @type {IdNamePair} */
        this.mpaa             = null;

        /** @type {IdNamePair} */
        this.naughtyScore     = null;

        /** @type {IdNamePair} */
        this.norbit           = null;

        /** @type {IdNamePair} */
        this.TV               = null;
    }
}
